import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { BiAddToQueue } from 'react-icons/bi';

import { Table } from 'services/action';

import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';
import useTable from 'ui/components/table';
import { FormUser } from 'ui/screens/authorized/_shared';

import tableConfig from './table.config';
import _ from 'underscore';

const initialState = {
  privilege: null,
  isShow: false,
};

const SettingUserScreen = () => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const UserTable = useTable('users', tableConfig);
  const StateTable = useSelector((state) => state?.Table?.data['users']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ isShow, privilege }, setState] = React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.user',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  return (
    <div className="sub-page">
      <div className="sub-page-navigation">
        <UserTable.Tools>
          {(!Session?.privileges || privilege?.action === 'manage') && (
            <button
              onClick={() =>
                setState((prevState) => ({ ...prevState, isShow: true }))
              }
              className="btn btn-primary py-1 ms-1"
            >
              <BiAddToQueue color="white" size="14" />
              <span className="d-none d-md-block ms-2">Tambah Pengguna</span>
            </button>
          )}
        </UserTable.Tools>
      </div>
      <div className="sub-page-body">
        {StateLoading ? (
          <SkeletonTable headerCount={6} bodyCount={10} />
        ) : (
          <UserTable.Render />
        )}
      </div>
      <div className="sub-page-footer">
        {StateLoading ? <SkeletonPageFooter /> : <UserTable.Pagination />}
      </div>

      <Modal
        show={isShow}
        onHide={() =>
          setState((prevState) => ({ ...prevState, isShow: false }))
        }
        backdrop="static"
        centered
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah User</Modal.Title>
        </Modal.Header>
        <FormUser
          onClose={() => {
            setState((prevState) => ({ ...prevState, isShow: false }));
          }}
          onSuccess={() => {
            setState((prevState) => ({ ...prevState, isShow: false }));
            Dispatch(Table.$reload('users', StateTable));
          }}
        />
      </Modal>
    </div>
  );
};

export default SettingUserScreen;
